/**
 * EventBloom — keeps the planner from being bought on its own.
 *
 * The planner is an add-on, not a standalone product: whenever it is the only
 * thing left in the cart it is removed, silently and with no message.
 *
 * Loaded from layout/theme.liquid, which passes the variant id derived from the
 * product itself via data-upsell-variant-id — nothing is hardcoded here, so a
 * variant change on Shopify carries over on its own. If that attribute comes
 * back empty (handle renamed, product unpublished) the guard disables itself
 * rather than touching a cart it cannot reason about.
 *
 * Runs on every page, not just where the upsell card is rendered, because a
 * customer can land on a cart that already holds nothing but the planner —
 * a direct link, an old session, a plain reload. Listening to cart events
 * alone would miss all of those, hence the check at load.
 */
(function () {
  if (window.__cartAddonGuardBound) return;
  window.__cartAddonGuardBound = true;

  var tag = document.querySelector('script[data-upsell-variant-id]');
  var ADDON_ID = tag ? (tag.getAttribute('data-upsell-variant-id') || '').trim() : '';

  if (!ADDON_ID) {
    console.warn(
      '[cart-addon-guard] no upsell variant id on the script tag — the planner ' +
        'product may have been unpublished or its handle changed. Guard disabled.'
    );
    return;
  }

  // Guards against re-entering while our own removal is still in flight.
  var running = false;

  /**
   * Removes the add-on when it is the last thing standing.
   * @param {{items?: Array<{variant_id: number|string}>}} cart
   */
  function enforce(cart) {
    if (running || !cart) return;

    var items = cart.items || [];
    if (!items.length) return;

    var hasAnchor = items.some(function (item) {
      return String(item.variant_id) !== ADDON_ID;
    });
    if (hasAnchor) return;

    var updates = {};
    updates[ADDON_ID] = 0;

    running = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { if (!r.ok) throw new Error('update failed'); return r.json(); })
      .then(function (updated) {
        // Re-render the drawer and /cart. The cart is empty by now, so the
        // listener below returns immediately and this cannot loop.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: updated, sourceId: 'cart-addon-guard', data: { source: 'cart-addon-guard' } }
        }));
      })
      .catch(function () { /* leave the cart as-is rather than half-updated */ })
      .then(function () { running = false; });
  }

  function checkFromServer() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(enforce)
      .catch(function () {});
  }

  // 1. At load — covers direct links, stale sessions and reloads.
  checkFromServer();

  // 2. On every cart change — covers removing the main product from the
  //    drawer or the cart page.
  document.addEventListener('cart:update', function (e) {
    var detail = e.detail || {};
    if (detail.data && detail.data.source === 'cart-addon-guard') return;

    var cart = detail.resource;
    if (cart && cart.items) enforce(cart);
    else checkFromServer();
  });
})();
